import React from 'react';
import { Field, CccisdWysiwyg } from 'cccisd-formik';
import { widgetBuilder } from 'cccisd-laravel-appdefs';

export const initialValues = {
    title: 'Group Log Report: Behavior',
    description:
        'The Log Report summarizes behavioral health data across all sessions for each participant in the group. This data can be used to determine if a participant needs additional behavioral health support. Ratios for each issue are presented as the number of behavioral selections made out of the total number of sessions.',
};

const Component = props => {
    return (
        <div>
            <Field name="title" component={CccisdWysiwyg} label="Title" />
            <Field name="description" component={CccisdWysiwyg} label="Description" />
        </div>
    );
};

// widgetBuilder is a Formik Wrapper.
export default widgetBuilder({ initialValues })(Component);
